(function () {
	"use strict";

	var PV_BASE = "https://uncheering-natasha-unshapely.ngrok-free.dev";

	function explain(message) {
		if (window.console && console.info)
			console.info("[pv-buybox] " + message);
	}

	function el(id) {
		return document.getElementById(id);
	}

	function numericId(value) {
		return String(value == null ? "" : value).split("/").pop();
	}

	function groupAmount(cents, decimals, thousands, decimalMark) {
		var fixed = (cents / 100).toFixed(decimals);
		var parts = fixed.split(".");
		var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
		return parts[1] ? whole + decimalMark + parts[1] : whole;
	}

	function formatMoney(cents, format) {
		if (typeof cents !== "number" || !isFinite(cents)) return "—";
		var amount = cents;

		var tokens = {
			amount: function () {
				return groupAmount(amount, 2, ",", ".");
			},
			amount_no_decimals: function () {
				return groupAmount(amount, 0, ",", ".");
			},
			amount_with_comma_separator: function () {
				return groupAmount(amount, 2, ".", ",");
			},
			amount_no_decimals_with_comma_separator: function () {
				return groupAmount(amount, 0, ".", ",");
			},
			amount_with_apostrophe_separator: function () {
				return groupAmount(amount, 2, "'", ".");
			},
		};

		var matched = false;
		var rendered = String(format || "").replace(
			/\{\{\s*(\w+)\s*\}\}/g,
			function (whole, token) {
				if (!tokens[token]) return whole;
				matched = true;
				return tokens[token]();
			}
		);

		return matched ? rendered : tokens.amount();
	}

	function fetchSiblings(shop, variantId) {
		return fetch(
			PV_BASE +
				"/webhooks/buy-box/siblings?shop=" +
				encodeURIComponent(shop) +
				"&variantId=" +
				encodeURIComponent(variantId),
			{
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					"ngrok-skip-browser-warning": "1",
				},
			}
		)
			.then(function (response) {
				if (!response.ok) throw new Error("HTTP " + response.status);
				return response.json();
			})
			.then(function (data) {
				return {
					reached: true,
					siblings: (data && data.siblings) || [],
				};
			})
			.catch(function (err) {
				return { reached: false, why: (err && err.message) || null };
			});
	}

	function purchasableVariant(product, preferredId) {
		var variants = product.variants || [];
		var inStock = variants.filter(function (variant) {
			return variant.available;
		});

		return (
			inStock.filter(function (variant) {
				return String(variant.id) === String(preferredId);
			})[0] || null
		);
	}

	function fetchLive(sibling) {
		return fetch("/products/" + encodeURIComponent(sibling.handle) + ".js")
			.then(function (response) {
				if (!response.ok) throw new Error("not found");
				return response.json();
			})
			.then(function (product) {
				var variant = purchasableVariant(product, sibling.variantId);
				if (!variant) return null;
				return {
					vendorName: sibling.vendorName,
					variantId: variant.id,
					matchedVariantId: sibling.variantId,
					price: variant.price,
				};
			})
			.catch(function () {
				return null;
			});
	}

	// Each row shows what that seller will charge for the chosen quantity, not a unit price, so
	// the figure matches what the shopper is about to add to the cart.
	function refreshRowPrices(root) {
		var format = root.getAttribute("data-pv-money-format");
		var quantity = chosenQuantity(root);
		var prices = root.querySelectorAll("[data-pv-unit-price]");

		for (var i = 0; i < prices.length; i++) {
			var unit = Number(prices[i].getAttribute("data-pv-unit-price"));
			prices[i].textContent = formatMoney(unit * quantity, format);
		}
	}

	function buildRow(offer) {
		var row = document.createElement("div");
		row.className = "pv-buybox__row";

		var meta = document.createElement("div");
		meta.className = "pv-buybox__meta";

		var vendor = document.createElement("span");
		vendor.className = "pv-buybox__vendor";
		vendor.textContent = offer.vendorName;
		meta.appendChild(vendor);

		var price = document.createElement("span");
		price.className = "pv-buybox__price";
		// The unit price stays on the element so multiplying by a new quantity never needs
		// another request, and refreshRowPrices stays the only place that writes this text.
		price.setAttribute("data-pv-unit-price", offer.price);

		var button = document.createElement("button");
		button.type = "button";
		button.className = "pv-buybox__btn";
		button.setAttribute("data-pv-buybox-add", "");
		button.setAttribute("data-variant-id", String(offer.variantId));
		button.textContent = "Add to cart";

		row.appendChild(meta);
		row.appendChild(price);
		row.appendChild(button);
		return row;
	}

	function fieldWrapperOf(control, form, scope, root) {
		var node = control;
		var parent = node.parentElement;
		while (
			parent &&
			parent !== scope &&
			!parent.contains(form) &&
			!parent.contains(root)
		) {
			node = parent;
			parent = node.parentElement;
		}
		return node;
	}

	var hiddenNativeControls = [];
	var nativeWatcher = null;

	function hideElement(element) {
		if (!element || element.hasAttribute("data-pv-native-hidden")) return;
		element.setAttribute("data-pv-native-hidden", "");
		hiddenNativeControls.push({
			element: element,
			display: element.style.display,
		});
		element.style.display = "none";
	}

	function restoreNativeControls() {
		if (nativeWatcher) {
			nativeWatcher.disconnect();
			nativeWatcher = null;
		}
		for (var i = 0; i < hiddenNativeControls.length; i++) {
			hiddenNativeControls[i].element.style.display =
				hiddenNativeControls[i].display;
			hiddenNativeControls[i].element.removeAttribute(
				"data-pv-native-hidden"
			);
		}
		hiddenNativeControls = [];
	}

	function hideOutsideBlock(root, scope, selector) {
		var hidden = [];
		if (!selector) return hidden;

		var matches = scope.querySelectorAll(selector);
		for (var i = 0; i < matches.length; i++) {
			if (root.contains(matches[i])) continue;
			hideElement(matches[i]);
			hidden.push(matches[i]);
		}
		return hidden;
	}

	// Every failure path must call restoreNativeControls: a shopper with no way to buy is
	// worse than a page offering two.
	function hideNativeControls(root, formSelector, priceSelector) {
		var scope = root.closest(".shopify-section") || document;

		var forms = hideOutsideBlock(root, scope, formSelector);
		var steppers = scope.querySelectorAll('[name="quantity"]');
		for (var i = 0; i < steppers.length; i++) {
			if (root.contains(steppers[i])) continue;
			hideElement(
				fieldWrapperOf(steppers[i], forms[0] || null, scope, root)
			);
		}

		hideOutsideBlock(root, scope, priceSelector);
	}

	/**
	 * Dawn re-renders this whole section on a variant change, replacing the elements
	 * hideNativeControls styled — so hiding once leaves a live stepper beside ours. Only
	 * childList is watched, so the style writes below cannot retrigger this.
	 */
	function keepNativeControlsHidden(root, formSelector, priceSelector) {
		hideNativeControls(root, formSelector, priceSelector);
		if (nativeWatcher || !window.MutationObserver) return;

		nativeWatcher = new MutationObserver(function () {
			hideNativeControls(root, formSelector, priceSelector);
		});
		nativeWatcher.observe(root.closest(".shopify-section") || document, {
			childList: true,
			subtree: true,
		});
	}

	function render(root, offers) {
		var rows = el("pv-buybox-rows");
		rows.textContent = "";
		offers.forEach(function (offer) {
			rows.appendChild(buildRow(offer));
		});

		var quantityBox = root.querySelector("[data-pv-buybox-qty]");
		if (quantityBox && !quantityBox.hasAttribute("data-pv-qty-bound")) {
			quantityBox.setAttribute("data-pv-qty-bound", "");
			quantityBox.addEventListener("input", function () {
				refreshRowPrices(root);
			});
		}
		refreshRowPrices(root);

		keepNativeControlsHidden(
			root,
			root.getAttribute("data-pv-native-form"),
			root.getAttribute("data-pv-native-price")
		);
		root.hidden = false;
	}

	function chosenQuantity(box) {
		var input = (box || document).querySelector("[data-pv-buybox-qty]");
		var value = parseInt(input && input.value, 10);
		return isFinite(value) && value > 0 ? value : 1;
	}

	function showAddToCartError(root, message) {
		var box = el("pv-buybox-error");
		if (!box) {
			box = document.createElement("div");
			box.id = "pv-buybox-error";
			box.className = "pv-buybox__error";
			box.setAttribute("role", "alert");
			root.appendChild(box);
		}
		box.textContent = message;
		box.hidden = false;
	}

	function markRowSoldOut(row, button, message) {
		if (!row) return;
		button.disabled = true;
		row.classList.add("pv-buybox__row--sold-out");

		var note = row.querySelector("[data-pv-buybox-row-note]");
		if (!note) {
			note = document.createElement("span");
			note.className = "pv-buybox__row-note";
			note.setAttribute("data-pv-buybox-row-note", "");
			note.setAttribute("role", "alert");
			var meta = row.querySelector(".pv-buybox__meta");
			(meta || row).appendChild(note);
		}
		note.textContent = message;
	}

	function clearAddToCartError() {
		var box = el("pv-buybox-error");
		if (box) box.hidden = true;
	}

	function addToCart(button) {
		var variantId = button.getAttribute("data-variant-id");
		if (!variantId) return;

		var row = button.closest(".pv-buybox__row");
		var quantity = chosenQuantity(button.closest(".pv-buybox"));
		var original = button.textContent;
		button.disabled = true;
		clearAddToCartError();

		fetch("/cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				items: [{ id: Number(variantId), quantity: quantity }],
			}),
		})
			.then(function (response) {
				if (!response.ok) {
					var failure = new Error("Add to cart failed");
					failure.status = response.status;
					throw failure;
				}
				window.location.href = "/cart";
			})
			.catch(function (error) {
				button.textContent = original;
				restoreNativeControls();

				if (error && error.status === 422) {
					markRowSoldOut(
						row,
						button,
						"Sold out — choose another seller."
					);
					return;
				}

				button.disabled = false;
				showAddToCartError(
					document.querySelector("[data-pv-buybox]") || document.body,
					"We couldn't add this to your cart. Please try again, or choose another seller."
				);
			});
	}

	document.addEventListener("click", function (event) {
		var button = event.target.closest("[data-pv-buybox-add]");
		if (button) addToCart(button);
	});

	var root = document.querySelector("[data-pv-buybox]");
	if (!root) return;

	var shopDomain = window.Shopify && window.Shopify.shop;
	if (!shopDomain || !root.getAttribute("data-pv-variant-id")) {
		explain(
			"not rendered: no request made — " +
				(shopDomain
					? "this page has no product variant, so the block has nothing to look up"
					: "window.Shopify.shop is unavailable") +
				"."
		);
		return;
	}

	var requestSeq = 0;
	var requestedVariantId = null;

	function currentVariantId() {
		var input = document.querySelector(
			'form[action*="/cart/add"] input[name="id"]'
		);
		if (input && input.value) return String(input.value);

		var fromUrl = /[?&]variant=(\d+)/.exec(window.location.search);
		if (fromUrl) return fromUrl[1];

		return root.getAttribute("data-pv-variant-id");
	}

	function clearBuyBox() {
		var rows = el("pv-buybox-rows");
		if (rows) rows.textContent = "";
		root.hidden = true;
		restoreNativeControls();
	}

	function showSiblingsFor(variantId) {
		var token = ++requestSeq;
		requestedVariantId = variantId;

		return fetchSiblings(shopDomain, variantId)
			.then(function (result) {
				if (token !== requestSeq) return;

				if (!result.reached) {
					explain(
						"not rendered: no sibling list from " +
							PV_BASE +
							" — " +
							(result.why ||
								"the request never completed (network or CORS)") +
							". HTTP 404 here means the buy-box route is missing from the " +
							"deployed backend, not that this product is ungrouped."
					);
					clearBuyBox();
					return;
				}

				var siblings = result.siblings;
				if (siblings.length === 0) {
					explain(
						"not rendered: PuppetVendors has no buy-box membership row for variant " +
							variantId +
							". Either this variant was never grouped, or the group is on a " +
							"different variant of this product."
					);
					clearBuyBox();
					return;
				}

				return Promise.all(siblings.map(fetchLive)).then(function (
					results
				) {
					if (token !== requestSeq) return;

					var offers = (results || []).filter(Boolean);
					var others = offers.filter(function (offer) {
						return numericId(offer.matchedVariantId) !== numericId(variantId);
					});
					if (!others.length) {
						explain(
							"not rendered: " +
								(offers.length === 0
									? "nothing in the group is purchasable right now"
									: "the only purchasable offer is this product itself, which the theme's own controls already sell") +
								" — " +
								siblings.length +
								" in the group, " +
								offers.length +
								" purchasable. The rest are sold out, unpublished, " +
								"or their handle no longer resolves."
						);
						clearBuyBox();
						return;
					}
					render(root, offers);
				});
			})
			.catch(function (err) {
				if (token !== requestSeq) return;
				explain(
					"not rendered: the seller lookup failed (" +
						((err && err.message) || "unknown error") +
						"), so the list was cleared rather than left showing another " +
						"variant's offers."
				);
				clearBuyBox();
			});
	}

	function onVariantMaybeChanged() {
		var next = currentVariantId();
		if (!next || next === requestedVariantId) return;
		showSiblingsFor(next);
	}

	document.addEventListener("change", function () {
		setTimeout(onVariantMaybeChanged, 0);
	});
	document.addEventListener("variant:change", onVariantMaybeChanged);
	if (
		typeof window.subscribe === "function" &&
		window.PUB_SUB_EVENTS &&
		window.PUB_SUB_EVENTS.variantChange
	) {
		window.subscribe(
			window.PUB_SUB_EVENTS.variantChange,
			onVariantMaybeChanged
		);
	}

	showSiblingsFor(currentVariantId());
})();
